module.exports = __webpack_public_path__ + "img/q3-1.3141db76.png";